import React from "react";
import { Grid, Typography, Container } from "@mui/material";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom";
import useMediaQueries from "utils/mediaQueries.utils";
import { StyledSectionContainer } from "styles/components";
import HeaderContainer from "styles/components/headerContainer";
import ThreeStackCard from "styles/components/threeStackCard";
import { ImageContainer } from "styles/components/imageContainer";
import { StyledTitleOverlay } from "pages/TherapyHub/components/resourcesSlider/index.styles";
import { StyledTitleText } from "pages/TherapyHub/components/resourcesSlider/index.styles";
import MKButton from "components/MKButton";

const convertTreatmentToAbbr = {
  "generalized anxiety disorder": "GAD",
  "obsessive-compulsive disorder": "OCD",
  "treatment-resistant depression": "TRD",
  "insomnia": "Insomnia",
  "attention deficit hyperactivity disorder": "ADHD",
  "post-traumatic stress disorder": "PTSD",
  "social anxiety disorder": "SAD",
};

const CardHubGrid = ({
  highlightText = [],
  title,
  description,
  data = [],
  textColor,
  highlightColor,
  gridItemProps = { xs: 12, sm: 6, md: 4 },
  headerVariant = "h2",
  headerComponent = "h2",
  ...props
}) => {
  const theme = useTheme();
  const { isLg } = useMediaQueries();

  const renderCard = (item) => {
    const topComponent = (
      <Container sx={{ padding: "0rem !important", margin: "0rem !important", position: "relative" }}>
        <ImageContainer image={item?.image?.src} alt={item?.image?.alt} cssProps={{ height: "215px", objectFit: "cover" }} />
        <StyledTitleOverlay>
          <StyledTitleText variant="h6" component="h3">
            {item.title || item.text}
          </StyledTitleText>
        </StyledTitleOverlay>
      </Container>
    );

    const bottomComponent = (
      <MKButton
        variant="contained"
        color="secondary"
        sx={{ width: "100%" }}
        component={Link}
        to={item.url}
        aria-label={item.ariaLabel || `Learn more about ${item.title}`}
      >
        Learn more about {convertTreatmentToAbbr[item.title.toLowerCase()] || item.title}
      </MKButton>
    );

    return <ThreeStackCard topComponent={topComponent} midComponent={null} botComponent={bottomComponent} />;
  };

  return (
    <StyledSectionContainer {...props}>
      <Grid container spacing={3} justifyContent="center">
        {title && description && (
          <Grid item xs={12}>
            <HeaderContainer
              title={title}
              highlightText={highlightText}
              textColor={textColor || theme.palette.primary.main}
              highlightColor={highlightColor || theme.palette.accent.main}
              component={headerComponent}
              variant={headerVariant}
              cssProps={{ margin: "0rem 0rem 1rem 0rem !important" }}
            />
            {description && (
              <Typography variant={isLg ? "body1" : "body2"} color="text.secondary">
                {description}
              </Typography>
            )}
          </Grid>
        )}
        {data.map((item) => (
          <Grid item {...gridItemProps} key={item.id}>
            {renderCard(item)}
          </Grid>
        ))}
      </Grid>
    </StyledSectionContainer>
  );
};

export default CardHubGrid;
